enum RequestCalloutTypes {
    overloadedCallout = 1,
    incidentCallout = 2
}

export default RequestCalloutTypes;